/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

export enum ImportProspects200SkippedItemReason {
  invalid_email = 'invalid_email',
  duplicate_in_file = 'duplicate_in_file',
  already_prospect = 'already_prospect',
  suppressed = 'suppressed'
}
